import {Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {CustomersDaoService} from '../../core/dao-service/customers-dao.service';
import {Customer} from '../../core/model/customer';

@Component({
  selector: 'app-customer-name',
  templateUrl: './customer-name.component.html',
  styleUrls: ['./customer-name.component.scss']
})
export class CustomerNameComponent implements OnInit {
  @Input() rowData: any;
  customer$: Observable<Customer>;

  constructor(private customersService: CustomersDaoService) {

  }

  ngOnInit() {
    if (this.rowData) {
      const customerId = this.rowData.customerId;
      if (customerId) {
        this.customer$ = this.customersService.get(customerId);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/customer-name/customer-name.component.ts